import { useState } from 'react'

import { dateToStr24HPad0DayOfWeek } from 'utils/convertFromLocalDate'
import { getAPI } from 'utils/getAPI'

import type {
  DlShipExpectedCsvDownloadCsvShipExpectedGetRequest,
  DlShipExpectedXlsxDownloadXlsxShipExpectedGetRequest,
} from 'api-client'

export const useShipExpectedFileDownload = () => {
  const [isCsvLoading, setIsCsvLoading] = useState(false)
  const [isXlsxLoading, setIsXlsxLoading] = useState(false)

  const fetchShipExpectedCsvDownload = async (
    filename: string,
    searchParam: DlShipExpectedCsvDownloadCsvShipExpectedGetRequest
  ) => {
    setIsCsvLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.dlShipExpectedCsvDownloadCsvShipExpectedGetRaw({
        ...searchParam,
        companyId: searchParam.companyId,
        centerId: searchParam.centerId || undefined,
        viewDateType: searchParam.viewDateType || undefined,
        viewUnitType: searchParam.viewUnitType || undefined,
        itemCode: searchParam.itemCode || undefined,
      })

      const blob = await response.raw.blob()
      const url = window.URL.createObjectURL(new Blob([blob], { type: blob.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filename}_${dateToStr24HPad0DayOfWeek(new Date(), 'YYYYMMDDhhmmss')}`)
      document.body.appendChild(link)
      link.click()
      link.parentNode?.removeChild(link)

      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      return undefined
    } finally {
      setIsCsvLoading(false)
    }
  }

  const fetchShipExpectedXlsxDownload = async (
    filename: string,
    searchParam: DlShipExpectedXlsxDownloadXlsxShipExpectedGetRequest
  ) => {
    setIsXlsxLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.dlShipExpectedXlsxDownloadXlsxShipExpectedGetRaw({
        ...searchParam,
        companyId: searchParam.companyId,
        centerId: searchParam.centerId || undefined,
        viewDateType: searchParam.viewDateType || undefined,
        viewUnitType: searchParam.viewUnitType || undefined,
        itemCode: searchParam.itemCode || undefined,
      })

      const blob = await response.raw.blob()
      const url = window.URL.createObjectURL(new Blob([blob], { type: blob.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filename}_${dateToStr24HPad0DayOfWeek(new Date(), 'YYYYMMDDhhmmss')}`)
      document.body.appendChild(link)
      link.click()
      link.parentNode?.removeChild(link)

      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      return undefined
    } finally {
      setIsXlsxLoading(false)
    }
  }

  return {
    fetchShipExpectedCsvDownload,
    isCsvLoading,
    fetchShipExpectedXlsxDownload,
    isXlsxLoading,
  }
}
